import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { ResourcesService } from '../../../services/resources.service';
import { DatePipe } from '@angular/common';
import { isEmpty } from 'rxjs';
import { ModalComponent } from '../../shared/modal/modal.component';
import * as BlobUtil from 'blob-util';
import { SowService } from '../../../services/sow.service';
import { ManualTSService } from '../../../services/manualts.service';

@Component({
  selector: 'app-manual-time-sheet',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
],
  templateUrl: './manual-time-sheet.component.html',
  styleUrls: ['./manual-time-sheet.component.scss'],
    providers: [
      DatePipe
    ]
})
export class ManualTimeSheetComponent implements OnInit {

  resource: any = {};
  listResourceSow: any = [];
  listEpic: any = [];
  listFeature: any = [];
  listTaskType: any = [];

  listPrimaryTask: any = [
    {value: 'Development', text: 'Development'},
    {value: 'Design', text: 'Design'},
    {value: 'Quality Assurance', text: 'Quality Assurance'},
    {value: 'Project Management', text: 'Project Management'},
    {value: 'Support', text: 'Support'}
  ]

  listType : any = [
    {value: 'CAPEX', text: 'CAPEX'},
    {value: 'OPEX', text: 'OPEX'}
  ]

  listCapexCode : any = [
    {value : '08.29', text: 'BSS - FABRICA DE SOFTWARE BSS	08.29'},
    {value : '08.26', text: 'INFRA IT - OTROS INFRAESTRUCTURA IT	08.26'},
    {value : '08.42', text: 'BI Y ANAYLTICS - OTROS BI Y ANALYTICS	08.42'},
    {value : '08.38', text: 'ERP - FABRICA DE SOFTWARE ERP	08.38'},
    {value : '08.47', text: 'OTROS IT - OTROS FABRICA DE SOFTWARE	08.47'},
    {value : '08.14', text: 'OTROS IT - SEGURIDAD Y CONTROL	08.14'}
  ]

  listTeam: any = [];
  listVendor: any = [];
  listContract: any = [];
  upload: any = {};

  constructor(
    private __ref: DynamicDialogRef,
    private __manualTSService : ManualTSService,
    private __datePipe: DatePipe,
    private __config: DynamicDialogConfig,
    private __dialogService : DialogService,
  ) {

  }

  ngOnInit(): void {
    this.getListResourceSow();
    this.getListEpic();
    this.getListTaskType();
    if (!this.isEmpty(this.__config.data.item)) {
      this.resource = this.__config.data.item;
      console.log(this.resource);
      this.getListTeamFeature();
    } else {
      this.resource.ID = 0;
    }
  }

  isEmpty(obj: any): boolean {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  }

  getListResourceSow() {
    //this.__spinner.show({ type: 'loader' });
    this.listResourceSow = [];
    this.__manualTSService.getListResourceSow().subscribe((resp: any) => {
      this.listResourceSow = resp.listResources;
      //.__spinner.close();
    });
  }

  selectItem(event: any) {
    console.log(event);
    let item = this.listResourceSow.find((e: any) => e.RESOURCE_ID == event);
    this.resource.RESOURCE_ID = item.RESOURCE_ID;
    this.resource.USER = item.USERNAME;
    this.resource.USERID = item.ADO_USERID;
    this.resource.TEAM = item.TEAM;
  }

  getListEpic() {
    //this.__spinner.show({ type: 'loader' });
    this.listEpic = [];
    this.__manualTSService.getListEpic().subscribe((resp: any) => {
      this.listEpic = resp.listEpic;
      //this.__spinner.close();
    });
  }

  selectEpic(event: any) {
    this.resource.EPIC_ID = event;
    let item = this.listEpic.find((e: any) => e.WORKITEMID == event);
    this.resource.EPIC_TITLE = item?.TITLE;
    this.resource.ORGANIZATION = item?.CUSTOM_ORGANIZATION;
    this.getListTeamFeature();
  }

  getListTeamFeature() {
    //this.__spinner.show({ type: 'loader' });
    this.listFeature = [];
    this.__manualTSService.getListTeamFeature(this.resource.EPIC_ID).subscribe((resp: any) => {
      this.listFeature = resp.listData;
      //this.__spinner.close();
    });
  }

  selectFeature(event: any) {
    let item = this.listFeature.find((e: any) => e.WORKITEMID == event);
    this.resource.FEATURE_ID = item.WORKITEMID;
    this.resource.FEATURE_TITLE = item.TITLE;
  }

  getListTaskType() {
    //this.__spinner.show({ type: 'loader' });
    this.listTaskType = [];
    this.__manualTSService.getListTaskType().subscribe((resp: any) => {
      this.listTaskType = resp.listTaskTipeList;
      //this.__spinner.close();
    });
  }

  saveManualTimeSheet() {
    //this.__spinner.show({ type: 'loader' });
    if (this.resource.RESOURCE_ID == undefined || this.resource.EPIC_ID == undefined || this.resource.TYPE == undefined ||
      this.resource.DATE == undefined || this.resource.EFFECTIVE_TIME == undefined || this.resource.MONTHLY_COST == undefined) {
        this.onShowMessage();
      return;
    }
    if (this.resource.RESOURCE_ID?.length == 0 || this.resource.EPIC_ID?.length == 0 || this.resource.TYPE?.length == 0 ||
      this.resource.DATE?.length == 0 || this.resource.EFFECTIVE_TIME?.length == 0 || this.resource.MONTHLY_COST?.length == 0) {
        this.onShowMessage();
      return;
    }
    this.resource.ORIGIN = 'MANUAL';
    this.resource.INALLENTRIES = 'Y';
    this.__manualTSService.saveManualTimeSheet(this.resource).subscribe((resp: any) => {
      if(+resp?.an_resultado==0) {
        //this.__spinner.close();
        this.accept();
      }
    });
  }

  /**
   *
   * @param event
   * @returns
   */
  handleFileInput(event : any) {
    this.upload.fileName = event.target.files[0].name;
    this.upload.fileType = event.target.files[0].type;
    BlobUtil.blobToBase64String(event.target.files[0]).then((res) => {
      this.upload.fileUpload = res;
      this.resource.SOWDOC = this.upload.fileUpload;
    });
  }

  onShowMessage() {
    let confirm = this.__dialogService.open(ModalComponent, {
      width: '30%',
      header: 'Complete fields required',
      dismissableMask: false,
      closable: false,
    });

    confirm?.onClose.subscribe((resp: any) => {
    });
  }

  cancel() {
    let data = {
      accion: 'cancel'
    }
    this.__ref.close(data);
  }

  accept() {
    let data = {
      accion: 'success'
    }
    this.__ref.close(data);
  }

}
